import { render, staticRenderFns } from "./CommonTab.vue?vue&type=template&id=5e87c18c&scoped=true"
import script from "./CommonTab.vue?vue&type=script&lang=js"
export * from "./CommonTab.vue?vue&type=script&lang=js"
import style0 from "./CommonTab.vue?vue&type=style&index=0&id=5e87c18c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e87c18c",
  null
  
)

export default component.exports